/** API e stato server dello storico resoconti (analisi AI + briefing di mercato). */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

/**
 * Tre generi (TODO.md): il digest giornaliero di portafoglio non compariva
 * affatto nello storico, pur essendo il documento da cui nascono gli ordini
 * automatici. È un genere a sé e non un `briefing` con un tipo diverso, perché
 * il filtro deve poterli separare senza guardare dentro un campo.
 */
// `rotation` era assente pur essendo emesso dal backend (F-075): la riga usciva
// con un badge vuoto. Il tipo qui deve rispecchiare `reports.service.ts`.
export type ReportKind = 'analysis' | 'briefing' | 'digest' | 'rotation';

export type ReportInstrumentTag = {
  id: string;
  name: string;
  symbol: string | null;
  isin: string | null;
};

export type ReportListItem = {
  id: string;
  kind: ReportKind;
  /** Analisi: `stock`/`crypto`. Briefing: sempre `market_briefing`. */
  reportType: string;
  title: string;
  instruments: ReportInstrumentTag[];
  marketMic: string | null;
  marketName: string | null;
  status: string;
  rating: string | null;
  triggeredBy: 'manual' | 'market_open_trigger' | null;
  createdAt: string;
  completedAt: string | null;
  detailPath: string;
};

export const reportsKeys = {
  list: ['reports', 'list'] as const,
};

export function useReports() {
  return useQuery({
    queryKey: reportsKeys.list,
    queryFn: ({ signal }) => api.get<{ items: ReportListItem[] }>('/reports', signal),
  });
}
